import { dropdownTemplate } from '../../templates/dropdown-template'
import { frequencyTemplate } from '../../templates/frequency-template'
import { Template } from '../../../models/template'

export const selectionFactory = (template: Template) => {
  switch (template) {
    case 'dropdown':
      return dropdownTemplate()
    case 'frequency':
    default:
      return frequencyTemplate()
  }
}
